
import { defineComponent, nextTick, onMounted } from "vue";
import { initializeComponents } from "@/core/plugins/keenthemes";
import { getModule } from "vuex-module-decorators";
import ConfigModule from "@/store/theme/ConfigModule";
import SystemConfigModule from "@/store/system/SystemConfigModule";
import { setLocale } from "@vee-validate/i18n";
import { lang } from "@/core/plugins/i18n";

export default defineComponent({
  name: "app",
  setup() {
    const configModule = getModule(ConfigModule);
    const systemConfigModule = getModule(SystemConfigModule);

    onMounted(async () => {
      /**
       * this is to override the layout config using saved data from localStorage
       * remove this to use config only from static config (@/core/config/DefaultLayoutConfig.ts)
       */
      configModule.overrideLayoutConfig();

      await systemConfigModule.getSystemConfig();

      setLocale(lang);

      nextTick(() => {
        initializeComponents();
      });
    });
  },
});
